<template>
  <b-col sm="12" :lg="lgSize">
    <b-card class="state" header="Received">
      <Modal
        title="Choose period"
        class="modal-primary"
        v-model="stateModal"
        @on-ok="fetchStateReport(), (stateModal = false)"
        :transfer="false"
      >
        <b-form>
          <b-form-group label="From" label-for="date" :label-cols="3">
            <datepicker use-utc
              format="MM/dd/yyyy"
              :bootstrap-styling="true"
              v-model="stateDateFrom"
              name="stateDateFrom"
            ></datepicker>
          </b-form-group>
          <b-form-group label="To" label-for="dateTo" :label-cols="3">
            <datepicker use-utc
              format="MM/dd/yyyy"
              :bootstrap-styling="true"
              v-model="stateDateTo"
              name="stateDateTo"
            ></datepicker>
          </b-form-group>
        </b-form>
      </Modal>
      <div slot="header" style="display:flex; justify-content: space-between;">
        <HeaderTitle
          title="Region Overview"
          :dateFrom="$formatUSDate(from(stateDateFrom))"
          :dateTo="$formatUSDate(to(stateDateTo))"
        ></HeaderTitle>
        <HeaderControl
          :showFullscreenIcon="true"
          :showDateIcon="true"
          @emit-fullscreen="toggleFullScreenState"
          @emit-date="stateModalEvent"
        ></HeaderControl>
      </div>
      <div style="width: 100%; display: flex; justify-content: flex-end;">
        <h5>Quantity</h5>
      </div>
      <div class="chart-wrapper">
        <LoadingCard v-if="loadingState"></LoadingCard>
        <div v-else>
          <highmaps
            style="height: 100%"
            ref="stateRef"
            :options="optionsMap"
          ></highmaps>
        </div>
      </div>
      <Modal
        size="lg"
        :title="selectedStateName"
        class="modal-primary cities"
        @on-ok="fetchChartStateDetails()"
        v-model="stateChartModal"
        :transfer="false"
      >
        <div class="checkbox" style="float: right">
          <label>
            <input
              v-model="selectAll"
              type="checkbox"
              :checked="true"
              class="form-check-input"
              name="foo"
            />
            Select All
          </label>
        </div>
        <br />
        <div class="modal-body">
          <div class="chart-wrapper">
            <LoadingCard v-if="StateChartDetails"></LoadingCard>
            <div v-else class="row">
              <div
                v-for="item in modalData"
                class="col-6 col-sm-6 col-md-4 col-xl-4 col-lg-4"
                :key="item.id"
              >
                <div class="checkbox">
                  <label>
                    <input
                      v-model="selectedModalLocations"
                      type="checkbox"
                      :checked="true"
                      class="form-check-input"
                      name="foo"
                      :value="item.id"
                    />
                    {{ item.fLoct }}
                  </label>
                </div>
              </div>
              <br />
            </div>
          </div>
          <br />
        </div>
      </Modal>
    </b-card>
  </b-col>
</template>

<script>
import Highcharts from "highcharts-vue";
import router from "../../../router";
import Datepicker from "vuejs-datepicker";
import usAll from "../../../utils/usAll";
import { Switch as cSwitch } from "@coreui/vue";
import HeaderTitle from "../../shared/HeaderTitle.vue";
import HeaderControl from "../../shared/HeaderControl.vue";
import LoadingCard from "../../shared/LoadingCard.vue";
import { from, isUserLoggedIn, to } from "../../../utils/Utils";

export default {
  name: "RegionOverview",
  components: {
    router,
    Highcharts,
    usAll,
    Datepicker,
    cSwitch,
    HeaderTitle,
    HeaderControl,
    LoadingCard
  },
  props: ["lgSize"],
  data: function() {
    return {
      from: from,
      to: to,
      selectedStateName: "",
      value: [20, 50],
      loadingState: false,
      valueQuantity: false,
      visible: false,
      selectAll: true,
      stateChartModal: false,
      stateDateFrom: "",
      stateDateTo: "",
      modalData: [],
      stateModal: false,
      fullscreenState: false,
      StateChartDetails: false,
      selectedModalLocations: [],
      optionsMap: {
        tooltip: {
          formatter: function() {
            return this.point.name + ": " + this.point.sign;
          }
        },
        chart: {
          map: usAll,
          backgroundColor: "transparent"
        },
        title: {
          text: ""
        },
        plotOptions: {
          map: {
            states: {
              hover: {
                color: "#EEDD66"
              }
            }
          },
          series: {
            stacking: "normal",
            point: {
              events: {
                click: ({ point }) => {
                  this.$refs.stateRef.chart.reflow();
                  this.selectedState = point.code;
                  this.selectedStateName = "Shipped to " + point.name + " - " + point.value + " Units";
                  this.stateChartModal = true;
                  this.fetchStateChartDetailsModal();
                }
              }
            }
          }
        },
        subtitle: {
          // text: 'Source map: <a href="http://code.highcharts.com/mapdata/countries/us/us-md-all.js">Maryland</a>'
          text: ""
        },
        mapNavigation: {
          enabled: true,
          buttonOptions: {
            verticalAlign: "bottom"
          }
        },
        colorAxis: {
          min: 0
        },
        series: [
          {
            mapData: usAll,
            data: this.data,
            joinBy: ["postal-code", "code"],
            name: "USA",
            color: "blue",
            states: {
              hover: {
                color: "#BADA55"
              }
            },
            dataLabels: {
              enabled: true,
              format: "{point.name}"
            }
          }
        ]
      }
    };
  },
  watch: {
    stateDateFrom() {
      this.stateDateFrom = from(this.stateDateFrom);
    },
    stateDateTo() {
      this.stateDateTo = from(this.stateDateTo);
    },
    selectAll(value) {
      if (!value) {
        this.selectedModalLocations = [];
      } else {
        this.modalData.forEach(value => {
          this.selectedModalLocations.push(value.id);
        });
      }
    },
    valueQuantity() {
      this.fetchStateReport();
      if (this.fullscreenState) {
        this.$refs.stateRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.stateRef.chart.options.chart.height = 400;
      }
    }
  },
  methods: {
    show() {
      this.visible = true;
    },
    fetchStateReport() {
      this.loadingState = true;
      let params = {};

      params = {
        date_from: from(this.stateDateFrom),
        date_to: to(this.stateDateTo),
        value: this.valueQuantity
      };
      this.$http.get("api/maps/stateReport.php", { params }).then(
        res => {
          this.data = res.data.records;
          this.data1 = this.data;
          this.optionsMap.series[0].data = this.data1;
          this.loadingState = false;
          setTimeout(() => {
            if (this.fullscreenState) {
              this.$refs.stateRef.chart.options.chart.height = "50%";
            } else {
              this.$refs.stateRef.chart.options.chart.height = 400;
            }
            this.$refs.stateRef.chart.reflow();
          });
        },
        err => {
          console.log(err);
          this.loadingState = false;
        }
      );
    },

    fetchStateChartDetailsModal() {
      this.StateChartDetails = true;
      let finType = "qty";
      let params = {};
      params = {
        type: finType,
        state: this.selectedState,
        date_from: from(this.stateDateFrom),
        date_to: to(this.stateDateTo)
      };
      this.$http
        .get("api/charts/locations_modal.php", {
          params
        })
        .then(
          res => {
            this.modalData = res.data.records;
            this.modalData.forEach(value => {
              this.selectedModalLocations.push(value.id);
            });

            this.StateChartDetails = false;
          },
          err => {
            console.log(err);
            this.StateChartDetails = false;
          }
        );
    },
    fetchChartStateDetails() {
      if (this.selectedModalProductGroup === "All product groups") {
        this.selectedModalProductGroup = "";
      }
      this.from(this.stateDateFrom);
      this.to(this.stateDateFrom);
      if (this.selectedModalLocations.length < 1) {
        alert("You must select at least one location ! ");
      } else {
        router.push(
          "/base/MapByState/?state=" +
            this.selectedState +
            "&date_from=" +
            this.stateDateFrom +
            "&date_to=" +
            this.stateDateTo +
            "&locations=" +
            this.selectedModalLocations
        );
      }
    },
    stateModalEvent() {
      this.stateModal = true;
    },
    toggleFullScreenState() {
      this.$fullscreen.toggle(this.$el.querySelector(".state"), {
        wrap: false,
        callback: this.fullscreenChangeState
      });
    },
    fullscreenChangeState(fullscreenState) {
      this.fullscreenState = fullscreenState;
      if (this.fullscreenState) {
        this.$refs.stateRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.stateRef.chart.options.chart.height = 400;
      }
      this.$refs.stateRef.chart.reflow();
    }
  },
  mounted() {
    isUserLoggedIn(router);
    this.locationsIds = localStorage.getItem("locations");

    this.valueQuantity = false;

    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 30)

    this.stateDateFrom = fromDate.toJSON().slice(0, 10);
    this.stateDateTo = new Date().toJSON().slice(0, 10);

    this.fetchStateReport();
  }
};
</script>
<style>
.ivu-modal-content {
  background: #3a4149 !important;
}
.cities .ivu-modal {
  width: 660px !important;
}
.ivu-modal-header p,
.ivu-modal-header-inner {
  color: white !important;
  font-size: 1.09375rem;
  font-weight: 500;
}
.ivu-modal-header {
  border-bottom: 1px solid #23282c !important;
  padding: 1rem;
}
.ivu-btn-text {
  color: #23282c;
  background-color: #acb5bc;
  border-color: #a5aeb7;
}
</style>
